<template>
  <div class="page-title">{{ $t("cleaning_page_title") }}</div>
  <div class="intro">{{ $t("cleaning_subtitle") }}</div>

  <el-container>
    <el-aside width="300px">
      <div>{{ $t("filter_by") }}</div>
      <el-collapse v-model="activeName" @change="handleChange" accordion>
        <el-collapse-item :title="$t('date')" name="1">
          <div class="actions">
            <ul>
              <li
                v-bind:class="{ active: date_sorting == 'ASC' }"
                @click="changeDateSorting('ASC')"
              >
                {{ $t("newest_first") }}
              </li>
              <li
                v-bind:class="{ active: date_sorting == 'DESC' }"
                @click="changeDateSorting('DESC')"
              >
                {{ $t("oldest_first") }}
              </li>
              <li>
                <el-checkbox
                  class="gkt-checkbox"
                  v-model="single_days"
                  :label="$t('single_days')"
                  border
                ></el-checkbox>

                <el-date-picker
                  v-if="single_days"
                  class="gkt-date-picker"
                  type="dates"
                  size="mini"
                  v-model="dates"
                  @change="setFilterDate()"
                  :placeholder="$t('pick_one_or_more_days')"
                >
                </el-date-picker>
                <el-date-picker
                  v-if="!single_days"
                  class="gkt-date-picker"
                  v-model="date_range"
                  type="daterange"
                  size="mini"
                  unlink-panels
                  :range-separator="$t('to')"
                  :start-placeholder="$t('start')"
                  :end-placeholder="$t('end')"
                  :shortcuts="shortcuts"
                  @change="setFilterDate()"
                >
                </el-date-picker>
                <el-checkbox
                  v-if="showTransmiteDates"
                  class="gkt-checkbox"
                  v-model="show_transferdate"
                  :label="$t('show_transferdate')"
                  border
                ></el-checkbox>
              </li>
            </ul>
          </div>
        </el-collapse-item>
        <el-collapse-item :title="$t('location')" name="2">
          <div class="actions">
            <ul>
              <li
                :class="{ active: location_sorting == 'ASC' }"
                @click="changeLocationSorting('ASC')"
              >
                {{ $t("asc") }}
              </li>
              <li
                :class="{ active: location_sorting == 'DESC' }"
                @click="changeLocationSorting('DESC')"
              >
                {{ $t("desc") }}
              </li>
              <li>
                <el-input
                  @change="changeCurrentSorting('location')"
                  :placeholder="$t('search_criteria')"
                  v-model="search_location"
                ></el-input>
              </li>
            </ul>
          </div>
        </el-collapse-item>
        <el-collapse-item
          :title="$t('provider')"
          name="3"
          v-if="store.state.login_type == 'mandate'"
        >
          <div class="actions">
            <ul>
              <li
                v-bind:class="{ active: provider_sorting == 'ASC' }"
                @click="changeProviderSorting('ASC')"
              >
                {{ $t("asc") }}
              </li>
              <li
                v-bind:class="{ active: provider_sorting == 'DESC' }"
                @click="changeProviderSorting('DESC')"
              >
                {{ $t("desc") }}
              </li>
              <li>
                <el-input
                  @change="changeCurrentSorting('provider')"
                  :placeholder="$t('search_criteria')"
                  v-model="search_provider"
                ></el-input>
              </li>
            </ul>
          </div>
        </el-collapse-item>
        <el-collapse-item :title="$t('service')" name="4">
          <div class="actions">
            <ul>
              <li
                v-bind:class="{ active: service_sorting == 'ASC' }"
                @click="changeServiceSorting('ASC')"
              >
                {{ $t("asc") }}
              </li>
              <li
                v-bind:class="{ active: service_sorting == 'DESC' }"
                @click="changeServiceSorting('DESC')"
              >
                {{ $t("desc") }}
              </li>
              <li>
                <el-input
                  @change="changeCurrentSorting('service')"
                  :placeholder="$t('search_criteria')"
                  v-model="search_service"
                ></el-input>
              </li>
            </ul>
          </div>
        </el-collapse-item>

        <el-collapse-item
          :title="$t('structurenumber')"
          name="5"
          v-if="hasExtraField"
        >
          <div class="actions">
            <ul>
              <li
                v-bind:class="{ active: structurenumber_sorting == 'ASC' }"
                @click="changestructurenumberSorting('ASC')"
              >
                {{ $t("asc") }}
              </li>
              <li
                v-bind:class="{ active: structurenumber_sorting == 'DESC' }"
                @click="changestructurenumberSorting('DESC')"
              >
                {{ $t("desc") }}
              </li>
              <li>
                <el-input
                  @change="changeCurrentSorting('structurenumber')"
                  :placeholder="$t('search_criteria')"
                  v-model="search_structurenumber"
                ></el-input>
              </li>
            </ul>
          </div>
        </el-collapse-item>
      </el-collapse>

      <el-button
        style="display:block;margin: 0 auto;margin-top: 48px;"
        type="default"
        @click="csvExport"
        icon="el-icon-paperclip"
        >{{ $t("export_to_csv") }}</el-button
      >
      <!-- confirmation for deleting -->
      <el-popconfirm
        v-if="store.state.deleteentries == true"
        :confirmButtonText="$t('yes')"
        :cancelButtonText="$t('no')"
        :title="$t('deleteentries_prompt')"
        @confirm="deleteAllEntries()"
      >
        <template #reference>
          <el-button
            style="display:block;margin: 0 auto;margin-top: 48px;"
            type="default"
            icon="el-icon-delete"
            >{{ $t("btn_deleteentries") }}</el-button
          >
        </template>
      </el-popconfirm>

      <el-checkbox
        v-if="store.state.login_type == 'mandate'"
        class="gkt-checkbox"
        v-model="automaticreports"
        :label="$t('report')"
        @click="enableSaveButton()"
        border
      ></el-checkbox>
      <el-form
        :model="ruleForm"
        :rules="rules"
        status-icon
        ref="ruleForm"
        v-if="store.state.login_type == 'mandate'"
      >
        <el-form-item prop="scheduler_reports" v-if="automaticreports">
          <Multiselect
            @change="enableSaveButton"
            :showToggleAll="false"
            v-model="ruleForm.scheduler_reports"
            optionLabel="name"
            optionValue="id"
            :options="scheduledControlReports"
            :placeholder="$t('time_schedule_none')"
          />
        </el-form-item>
        <el-form-item
          prop="scheduler_reports_days"
          v-if="
            ruleForm.scheduler_reports.join(' ').includes('week') &&
              automaticreports
          "
        >
          <Multiselect
            @change="enableSaveButton2"
            :showToggleAll="false"
            v-model="ruleForm.scheduler_reports_days"
            optionLabel="name"
            optionValue="id"
            :options="scheduledControlListDays"
            :placeholder="$t('time_schedule_error_dayinmonth')"
          />
        </el-form-item>
        <el-form-item
          prop="scheduler_reports_daynumber"
          v-if="
            ruleForm.scheduler_reports.join(' ').includes('month') &&
              automaticreports
          "
        >
          <Multiselect
            @change="enableSaveButton3"
            :showToggleAll="false"
            v-model="ruleForm.scheduler_reports_daynumber"
            optionLabel="name"
            optionValue="id"
            :options="scheduledControlListDayNumber"
            :placeholder="$t('time_schedule_none')"
          />
        </el-form-item>
        <el-form-item prop="email" v-if="automaticreports">
          <el-input
            @input="enableSaveButton()"
            :placeholder="$t('email_address')"
            type="email"
            v-model="ruleForm.email"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            :style="{ visibility: report_save ? 'visible' : 'hidden' }"
            style="display:block;margin: 0 auto;margin-top: 12px;"
            type="default"
            @click="submitForm('ruleForm')"
            id="idsavebutton"
            >{{ $t("save") }}</el-button
          >
        </el-form-item>
      </el-form>
    </el-aside>
    <el-main>
      <table
        v-loading="loading"
        :element-loading-text="$t('loading')"
        element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)"
      >
        <thead>
          <tr>
            <td>{{ $t("date") }}</td>
            <td v-if="show_transferdate">{{ $t("date") }}</td>
            <td>{{ $t("location") }}</td>
            <td>{{ $t("provider") }}</td>
            <td>{{ $t("service") }}</td>
            <td>{{ $t("status") }}</td>
            <td v-if="hasExtraField">{{ $t(hasExtraFieldName) }}</td>
            <td v-if="show_deleteentry">{{ $t("actions") }}</td>
          </tr>
        </thead>
        <tbody
          v-infinite-scroll="load"
          infinite-scroll-disabled="disabled"
          style="overflow-y:scroll"
        >
          <tr
            v-for="i in filteredAndSortedData"
            v-bind:key="i"
            class="infinite-list-item"
          >
            <td>{{ i.date }}</td>
            <td v-if="show_transferdate">{{ i.date_created }}</td>
            <td v-if="i.vgroup && i.vgroup != ''">
              {{ i.name }} <br />({{ i.vgroup }})
            </td>
            <td v-if="!i.vgroup || i.vgroup == ''">{{ i.name }}</td>
            <td>{{ i.provider }}</td>
            <td>{{ i.service }}</td>
            <td>
              {{ i.beginend == "end" ? $t("status_end") : $t("status_begin") }}
            </td>
            <td v-if="hasExtraField">{{ i.strukturnummer }}</td>

            <td v-if="show_deleteentry">
              <el-popconfirm
                :confirmButtonText="$t('yes')"
                :cancelButtonText="$t('no')"
                :title="$t('deleteentry_prompt')"
                @confirm="deleteEntry(i.idcleaningDates)"
              >
                <template #reference>
                  <el-button
                    style="display:block;margin: 0 auto;padding:15px;"
                    type="default"
                    icon="el-icon-delete"
                    >{{ $t("deleteentry_msg") }}</el-button
                  >
                </template>
              </el-popconfirm>
            </td>
          </tr>
        </tbody>
      </table>
      <el-alert
        v-if="noMore"
        :title="$t('all_services_loaded')"
        type="success"
        center
        show-icon
      >
      </el-alert>
    </el-main>
  </el-container>
</template>

<style lang="scss" scoped>
.el-container {
  margin-top: 24px;
  max-height: calc(100% - 124px);
  border-radius: 24px;
}
:deep(div.gkt-date-picker) {
  width: 180px;

  input {
    font-size: 9px;
  }

  span.el-range-separator {
    font-size: 8px;
    width: 22px;
  }
}

:deep(label.gkt-checkbox) {
  display: block;
  margin-bottom: 6px;
  color: $gkt-white !important;

  span {
    color: $gkt-white !important;
  }
}

.actions {
  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    padding: 12px 0;

    li {
      cursor: pointer;
      margin-bottom: 8px;
      display: block;
      color: $gkt-white;

      &.active {
        font-weight: bold;
      }
    }
  }
}

.el-aside {
  background-color: $gkt-orange;
  border-top-left-radius: 21px;
  border-bottom-left-radius: 21px;
  padding: 24px 30px;
  padding-right: 62px;
  overflow: scroll-y;

  .el-collapse {
    margin-top: 24px;
    border: 0;

    .el-collapse-item {
      :deep(.el-collapse-item__header),
      :deep(.el-collapse-item__wrap) {
        background-color: transparent !important;
        color: #ffffff;
        font-weight: normal;
      }

      :deep(.el-collapse-item__header) {
        border-bottom-color: #fdfdfd;
      }
    }
  }
}

.el-main {
  padding: 0;
  background-color: $gkt-light-grey;
  padding: 24px;
  border-radius: 21px;
  position: relative;
  margin-left: -42px;

  table {
    height: calc(100% - 100px);
    margin-bottom: 24px;
    border-collapse: collapse;

    @media screen and(max-width: 1021px) {
      width: 837px;
      overflow: scroll;
    }

    thead {
      display: block;
      overflow-y: scroll;

      &::-webkit-scrollbar {
        visibility: hidden;
      }

      tr {
        display: table;
        width: 100%;
        table-layout: fixed;

        td {
          text-align: center;
          border-right: 3px solid #ffffff;
          border-bottom: 3px solid #ffffff;
          font-weight: 500;
          padding: 6px;
          width: 20%;
          word-break: normal;

          &:last-child {
            border-right: 0;
          }
        }
      }
    }

    tbody {
      display: block;
      height: calc(100% - 24px);
      overflow: auto;

      tr {
        display: table;
        width: 100%;
        table-layout: fixed;

        &:nth-child(even) {
          background-color: darken($gkt-light-grey, 2);
        }

        td {
          text-align: center;
          border-right: 3px solid #ffffff;
          padding: 6px;
          width: 20%;
          word-break: normal;

          &:last-child {
            border-right: 0;
          }
        }
      }
    }
  }
}
.p-multiselect {
  width: 100%;
  border-radius: 35px;
  padding-left: 24px;
  height: 44px;

  :deep(.p-multiselect-label) {
    padding: 0;
  }
}
</style>
<style>
.el-form-item__error {
  color: white !important;
}
</style>
<script>
import { provide } from "vue";
import store from "@/store";
import Multiselect from "primevue/multiselect";

export default {
  name: "cleaning",
  setup() {
    provide("store", store);
  },

  components: {
    Multiselect
  },
  data() {
    var validatescheduler_reports = (rule, value, callback) => {
      if (value == "") {
        if (this.automaticreports) {
          callback(new Error(this.$t("time_schedule_error_plan")));
        } else {
          callback();
        }
      } else {
        if (this.ruleForm.scheduler_reports !== "") {
          //this.$refs.ruleForm.validateField("scheduler_reports");
        }
        callback();
      }
    };
    var validatescheduler_reports_days = (rule, value, callback) => {
      if (value == "") {
        if (
          this.ruleForm.scheduler_reports.join(" ").includes("week") &&
          this.automaticreports
        ) {
          callback(new Error(this.$t("time_schedule_error_day")));
        } else {
          callback();
        }
      } else {
        if (this.ruleForm.scheduler_reports_days !== "") {
          //this.$refs.ruleForm.validateField("scheduler_reports_days");
        }
        callback();
      }
    };
    var validatescheduler_reports_daynumber = (rule, value, callback) => {
      if (value == "") {
        if (
          this.ruleForm.scheduler_reports.join(" ").includes("month") &&
          this.automaticreports
        ) {
          callback(new Error(this.$t("time_schedule_error_dayinmonth")));
        } else {
          callback();
        }
      } else {
        if (this.ruleForm.scheduler_reports_days !== "") {
          //this.$refs.ruleForm.validateField("scheduler_reports_days");
        }
        callback();
      }
    };
    var validateEmail = (rule, value, callback) => {
      if (value == "") {
        callback(new Error(this.$t("enter_email")));
      } else if (!this.testEmailasList(value)) {
        callback(new Error(this.$t("enter_valid_email")));
      } else {
        callback();
      }
    };

    return {
      ruleForm: {
        scheduler_reports: [],
        scheduler_reports_days: [],
        scheduler_reports_daynumber: [],
        email: ""
      },
      rules: {
        scheduler_reports: [
          { validator: validatescheduler_reports, trigger: "blur" }
        ],
        scheduler_reports_days: [
          { validator: validatescheduler_reports_days, trigger: "blur" }
        ],
        scheduler_reports_daynumber: [
          { validator: validatescheduler_reports_daynumber, trigger: "blur" }
        ],
        email: [{ validator: validateEmail, trigger: "blur" }]
      },
      single_days: false,
      show_transferdate: false,
      show_deleteentry: false,
      hasExtraField: false,
      shortcuts: [
        {
          text: this.$t("last_week"),
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            return [start, end];
          })()
        },
        {
          text: this.$t("last_month"),
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            return [start, end];
          })()
        },
        {
          text: this.$t("last_3_months"),
          value: (() => {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            return [start, end];
          })()
        }
      ],

      dates: "",
      automaticreports: false,
      report_save: false,
      date_range: "",
      activeName: ["1"],
      cleaningData: [],
      locations: [],
      count: 0,
      tab_index: 1,
      loading: false,
      current_sorter: "date",
      search_location: "",
      search_provider: "",
      search_service: "",
      search_date: "",
      search_structurenumber: "",
      location_sorting: "ASC",
      date_sorting: "ASC",
      service_sorting: "ASC",
      provider_sorting: "ASC",
      structurenumber_sorting: "ASC",
      filter_date: "",
      scheduledControlReports: [
        { name: this.$t("time_schedule_every_week"), id: "everyweek" },
        { name: this.$t("time_schedule_every_weekodd"), id: "everyweekodd" },
        { name: this.$t("time_schedule_every_weekeven"), id: "everyweekeven" },
        { name: this.$t("time_schedule_every_month"), id: "everymonth" },
        { name: this.$t("time_schedule_every_month3"), id: "everymonth3" }
      ],
      scheduledControlListDays: [
        { name: this.$t("monday"), id: 1 },
        { name: this.$t("tuesday"), id: 2 },
        { name: this.$t("wednesday"), id: 3 },
        { name: this.$t("thursday"), id: 4 },
        { name: this.$t("friday"), id: 5 },
        { name: this.$t("saturday"), id: 6 },
        { name: this.$t("sunday"), id: 0 }
      ],
      scheduledControlListDayNumber: [],
      store
    };
  },
  updated() {},
  watch: {
    report_save: function(val) {
      if (val != 0) {
        this.$nextTick().then(() => {
          var s = document.getElementById("idsavebutton");
          if (s) {
            s.scrollIntoView({ behavior: "smooth" });
          }
        });
      }
    },
    automaticreports: function() {
      if (this.report_save) {
        this.$nextTick().then(() => {
          var s = document.getElementById("idsavebutton");
          if (s) {
            s.scrollIntoView({ behavior: "smooth" });
          }
        });
      }
    }
  },

  computed: {
    noMore() {
      return this.count >= 50;
    },
    showTransmiteDates() {
      if (window.location.search.search("showtransmitdate=1") >= 0) {
        return true;
      }
      return false;
    },

    disabled() {
      return this.loading || this.noMore;
    },
    filteredAndSortedData() {
      let result = this.cleaningData;
      let location_sorting = this.location_sorting;
      let date_sorting = this.date_sorting;
      let provider_sorting = this.provider_sorting;
      let service_sorting = this.service_sorting;
      let structurenumber_sorting = this.structurenumber_sorting;
      let tmp_result = result;
      let sorter = this.current_sorter;
      let filter_date = this.filter_date;
      let single_days = this.single_days;
      let dates = [];

      if (filter_date !== "") {
        for (let index in filter_date) {
          const date = filter_date[index];

          const formattedDate = new Date(date);

          formattedDate.setDate(formattedDate.getDate() + 1);
          const check_date_formatted = formattedDate
            .toISOString()
            .split("T")[0];

          dates.push(check_date_formatted);
        }
      }

      if (sorter == "date") {
        tmp_result = tmp_result.sort(function(a, b) {
          return date_sorting == "ASC"
            ? -a.date.localeCompare(b.date)
            : a.date.localeCompare(b.date);
        });
      }

      if (single_days) {
        if (dates.length) {
          tmp_result = tmp_result.filter(function(d) {
            const formattedDate = new Date(d.date);
            const check = formattedDate.toISOString().split("T")[0];

            return dates.includes(check);
          });
        }
      } else {
        if (dates.length) {
          tmp_result = tmp_result.filter(function(d) {
            const formattedDate = new Date(d.date);
            const check = formattedDate.toISOString().split("T")[0];

            if (dates[0] == dates[1]) {
              return check == dates[0];
            }

            return check >= dates[0] && check <= dates[1];
          });
        }
      }

      if (sorter == "location") {
        tmp_result = tmp_result.sort(function(a, b) {
          return location_sorting == "ASC"
            ? a.name.localeCompare(b.name)
            : -a.name.localeCompare(b.name);
        });
      }

      if (this.search_location != "") {
        let search_location = this.search_location.toLowerCase();

        tmp_result = tmp_result.filter(function(item) {
          return item.name.toLowerCase().indexOf(search_location) !== -1;
        });
      }

      if (sorter == "provider") {
        tmp_result = tmp_result.sort(function(a, b) {
          return provider_sorting == "ASC"
            ? a.provider.localeCompare(b.provider)
            : -a.provider.localeCompare(b.provider);
        });
      }

      if (this.search_provider != "") {
        let search_provider = this.search_provider.toLowerCase();

        tmp_result = tmp_result.filter(function(item) {
          return item.provider.toLowerCase().indexOf(search_provider) !== -1;
        });
      }

      if (sorter == "service") {
        tmp_result = tmp_result.sort(function(a, b) {
          return service_sorting == "ASC"
            ? a.service.localeCompare(b.service)
            : -a.service.localeCompare(b.service);
        });
      }

      if (this.search_service != "") {
        let search_service = this.search_service.toLowerCase();

        tmp_result = tmp_result.filter(function(item) {
          return item.service.toLowerCase().indexOf(search_service) !== -1;
        });
      }

      if (sorter == "structurenumber") {
        tmp_result = tmp_result.sort(function(a, b) {
          return structurenumber_sorting == "ASC"
            ? a.strukturnummer.localeCompare(b.strukturnummer)
            : -a.strukturnummer.localeCompare(b.strukturnummer);
        });
      }

      if (this.search_structurenumber != "") {
        let search_structurenumber = this.search_structurenumber.toLowerCase();

        tmp_result = tmp_result.filter(function(item) {
          return (
            item.strukturnummer
              .toLowerCase()
              .indexOf(search_structurenumber) !== -1
          );
        });
      }

      return tmp_result;
    }
  },
  methods: {
    enableSaveButton(a) {
      if (a) {
        var t = a.value.length;
        if (t > 0) {
          var lastadded = a.value[t - 1];
          var filterout = "nothing";
          if (lastadded.includes("week")) filterout = "week";
          //if (lastadded.includes("month"))
          //	filterout="month";
          var newdata = [];
          for (var b = 0; b < t; b++) {
            if (!a.value[b].includes(filterout)) {
              newdata.push(a.value[b]);
            }
          }
          if (!newdata.includes(lastadded)) {
            newdata.push(lastadded);
          }

          this.ruleForm.scheduler_reports = newdata;
        }
      }
      this.report_save = this.report_save + 1;
    },
    enableSaveButton2(a) {
      if (a) {
        var t = a.value.length;
        if (t > 0) {
          var lastadded = a.value[t - 1];
          this.ruleForm.scheduler_reports_days = [lastadded];
        }
      }
      this.report_save = this.report_save + 1;
    },
    enableSaveButton3(a) {
      if (a) {
        var t = a.value.length;
        if (t > 0) {
          var lastadded = a.value[t - 1];
          this.ruleForm.scheduler_reports_daynumber = [lastadded];
        }
      }
      this.report_save = this.report_save + 1;
    },

    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const parameters = {
            reportscheduler: { plans: [] }
          };

          const that = this;
          if (this.automaticreports) {
            this.ruleForm.scheduler_reports.forEach(function(reporttype) {
              if (reporttype != "none") {
                if (reporttype.includes("week")) {
                  parameters.reportscheduler.plans.push({
                    type: reporttype,
                    onday: that.ruleForm.scheduler_reports_days[0],
                    email: that.ruleForm.email
                  });
                }
                if (reporttype.includes("month")) {
                  parameters.reportscheduler.plans.push({
                    type: reporttype,
                    onday: that.ruleForm.scheduler_reports_daynumber[0],
                    email: that.ruleForm.email
                  });
                }
              }
            });
          } else {
            this.ruleForm.scheduler_reports = [];
          }
          const response = await this.$root.store.methods.apiRequest(
            "setreportschedule",
            parameters
          );
          const res = response.data;
          this.loading = false;
          if (res.status == "success") {
            this.report_save = 0;
            this.$message({
              showClose: true,
              message: this.$t("save_report"),
              type: "success",
              offset: 350
            });
          } else {
            this.$message({
              showClose: true,
              message: res.errordetails,
              type: "error",
              offset: 350
            });
          }
        }
      });
    },
    async deleteEntry(id) {
      const parameters = {
        identry: id
      };

      const response = await this.$root.store.methods.apiRequest(
        "deleteentry",
        parameters
      );
      const res = response.data;
      if (res.status == "success") {
        this.$message({
          showClose: true,
          message: this.$t("deleteentry_success"),
          type: "success",
          offset: 350
        });

        this.cleaningData = response.data.results.cleaningdata;
      } else {
        this.$message({
          showClose: true,
          message: this.$t("deleteentry_fail"),
          type: "error",
          offset: 350
        });
      }
    },
    async deleteAllEntries() {
      const response = await this.$root.store.methods.apiRequest(
        "deleteentries"
      );
      const res = response.data;
      if (res.status == "success") {
        this.$message({
          showClose: true,
          message: this.$t("deleteentries_success"),
          type: "success",
          offset: 350
        });
        this.cleaningData = [];
      } else {
        this.$message({
          showClose: true,
          message: this.$t("deleteentries_fail"),
          type: "error",
          offset: 350
        });
      }
    },
    csvExport() {
      let csvContent = "";
      const arrData = this.filteredAndSortedData;

      if (this.hasExtraField) {
        csvContent += [
          this.$t("date") +
            ";" +
            "Strukturnummer" +
            ";" +
            this.$t("location") +
            ";" +
            this.$t("provider") +
            ";" +
            this.$t("service") +
            ";" +
            this.$t("status"),
          ...arrData.map(
            item =>
              item.date +
              ";" +
              item.strukturnummer +
              ";" +
              item.name +
              ";" +
              item.provider +
              ";" +
              item.service +
              ";" +
              (item.beginend == "end"
                ? this.$t("status_end")
                : this.$t("status_begin"))
          )
        ]
          .join("\n")
          .replace(/(^\[)|(\]$)/gm, "");
      } else {
        csvContent += [
          this.$t("date") +
            ";" +
            this.$t("location") +
            ";" +
            this.$t("provider") +
            ";" +
            this.$t("service") +
            ";" +
            this.$t("status"),
          ...arrData.map(
            item =>
              item.date +
              ";" +
              item.name +
              ";" +
              item.provider +
              ";" +
              item.service +
              ";" +
              (item.beginend == "end"
                ? this.$t("status_end")
                : this.$t("status_begin"))
          )
        ]
          .join("\n")
          .replace(/(^\[)|(\]$)/gm, "");
      }

      const csvString = csvContent;
      const link = document.createElement("a");
      link.setAttribute(
        "href",
        "data:text/csv;charset=utf-8,%EF%BB%BF" + encodeURI(csvString)
      );
      link.setAttribute("download", "export.csv");
      link.click();
    },
    setFilterDate() {
      if (this.single_days) {
        this.date_range = "";
        this.filter_date = this.dates;
      } else {
        this.dates = "";
        this.filter_date = this.date_range;
      }
    },
    handleChange(val) {
      this.tab_index = val;

      if (val == 1) {
        this.current_sorter = "date";
      }

      if (val == 2) {
        this.current_sorter = "location";
      }

      if (val == 3) {
        this.current_sorter = "provider";
      }

      if (val == 4) {
        this.current_sorter = "service";
      }
      if (val == 5) {
        this.current_sorter = "structurenumber";
      }
    },
    changeCurrentSorting(val) {
      this.current_sorter = val;
    },
    changeLocationSorting(sort) {
      this.location_sorting = sort;

      this.current_sorter = "location";
    },
    changeProviderSorting(sort) {
      this.provider_sorting = sort;

      this.current_sorter = "provider";
    },
    changeDateSorting(sort) {
      this.date_sorting = sort;

      this.current_sorter = "date";
    },
    changeServiceSorting(sort) {
      this.service_sorting = sort;

      this.current_sorter = "service";
    },
    changestructurenumberSorting(sort) {
      this.structurenumber_sorting = sort;

      this.current_sorter = "structurenumber";
    },
    load() {
      this.loading = true;
      setTimeout(() => {
        this.count += 10;
        this.loading = false;
      }, 250);
    },
    testEmailasList(emails) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      const list = emails.split(",");
      console.log("start");
      let status = true;
      list.forEach(s => {
        if (!re.test(String(s).toLowerCase())) {
          status = false;
        }
      });
      return status;
    }
  },

  async mounted() {
    this.scheduledControlListDayNumber.push({
      name: this.$t("time_schedule_firstdayofmonth"),
      id: 1
    });
    this.scheduledControlListDayNumber.push({
      name: this.$t("time_schedule_lastdayofmonth"),
      id: -1
    });
    for (let a = 2; a <= 31; a++) {
      this.scheduledControlListDayNumber.push({ name: a, id: a });
    }
    const responseScheduler = await this.$root.store.methods.apiRequest(
      "getreportschedule"
    );

    const resScheduler = responseScheduler.data;

    const response = await this.$root.store.methods.apiRequest(
      "getcleaningdata"
    );
    if (resScheduler.results && resScheduler.results.reportscheduler) {
      const plans = [];
      var dayinmonth = "";
      var day = "";
      for (var index in resScheduler.results.reportscheduler.plans) {
        const reporttype = resScheduler.results.reportscheduler.plans[index];
        plans.push(reporttype.type);
        if (reporttype.type.includes("week")) {
          day = reporttype.onday;
        }
        if (reporttype.type.includes("month")) {
          dayinmonth = reporttype.onday;
        }
        this.ruleForm.email = reporttype.email;
      }
      this.ruleForm.scheduler_reports = plans;
      this.ruleForm.scheduler_reports_daynumber = [];
      this.ruleForm.scheduler_reports_days = [];
      if (dayinmonth != "")
        this.ruleForm.scheduler_reports_daynumber = [dayinmonth];
      if (day != "") this.ruleForm.scheduler_reports_days = [day];
      if (day == "0") this.ruleForm.scheduler_reports_days = [day];
      if (this.ruleForm.scheduler_reports.length > 0) {
        this.automaticreports = true;
      }
    }
    this.show_deleteentry = false;
    if (window.location.search.search("showtdeleteentry=1") >= 0) {
      this.show_deleteentry = true;
    }

    const res = response.data;

    if (res.errordetails) {
      console.log("error", res.errordetails);
    }

    if (
      res.results &&
      res.results.cleaningdata &&
      res.results.cleaningdata.length > 0
    ) {
      this.cleaningData = res.results.cleaningdata;
      const i = this.cleaningData[0];
      this.hasExtraField = false;
      if (typeof i.strukturnummer != "undefined") {
        this.hasExtraField = true;
        this.hasExtraFieldName = "structurenumber";
      }
    }
  }
};
</script>
